import Vue from 'vue';
import 'ant-design-vue/dist/antd.css';
import { Modal, Drawer, TreeSelect } from 'ant-design-vue';

Vue.use(Modal);
Vue.use(Drawer);
Vue.use(TreeSelect);
